var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.fiscalTaxParameter.ratesVisible
    ? _c(
        "div",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "3" } },
                [
                  _c("FormulateInput", {
                    staticClass: "required",
                    attrs: {
                      id: "tax-parameter-cbs-percent",
                      name: "tax-parameter-cbs-percent",
                      type: "text-percetage",
                      currency: "%",
                      precision: 5,
                      validation: "required|number|min:0.0000|max:1",
                      "validation-messages": Object.assign(
                        {},
                        _vm.mxGetTextPercentageValidationMessages
                      ),
                      label: _vm.$t("FISCAL_TAX_PARAMETER.LABEL.CBS_PERCENT"),
                    },
                    model: {
                      value: _vm.fiscalTaxParameter.cbsPercent,
                      callback: function ($$v) {
                        _vm.$set(_vm.fiscalTaxParameter, "cbsPercent", $$v)
                      },
                      expression: "fiscalTaxParameter.cbsPercent",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "3" } },
                [
                  _c("FormulateInput", {
                    staticClass: "required",
                    attrs: {
                      id: "tax-parameter-cbs-reduction-percent",
                      name: "tax-parameter-cbs-reduction-percent",
                      type: "text-percetage",
                      currency: "%",
                      precision: 5,
                      validation: "required|number|min:0.0000|max:1",
                      "validation-messages": Object.assign(
                        {},
                        _vm.mxGetTextPercentageValidationMessages
                      ),
                      label: _vm.$t(
                        "FISCAL_TAX_PARAMETER.LABEL.CBS_REDUCTION_PERCENT"
                      ),
                    },
                    model: {
                      value: _vm.fiscalTaxParameter.cbsReductionPercent,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.fiscalTaxParameter,
                          "cbsReductionPercent",
                          $$v
                        )
                      },
                      expression: "fiscalTaxParameter.cbsReductionPercent",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "3" } },
                [
                  _c("FormulateInput", {
                    staticClass: "required",
                    attrs: {
                      id: "tax-parameter-cbs-deferral-percent",
                      name: "tax-parameter-cbs-deferral-percent",
                      type: "text-percetage",
                      currency: "%",
                      precision: 5,
                      validation: "required|number|min:0.0000|max:1",
                      "validation-messages": Object.assign(
                        {},
                        _vm.mxGetTextPercentageValidationMessages
                      ),
                      label: _vm.$t(
                        "FISCAL_TAX_PARAMETER.LABEL.CBS_DEFERRAL_PERCENT"
                      ),
                    },
                    model: {
                      value: _vm.fiscalTaxParameter.cbsDeferralPercent,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.fiscalTaxParameter,
                          "cbsDeferralPercent",
                          $$v
                        )
                      },
                      expression: "fiscalTaxParameter.cbsDeferralPercent",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }